export default __webpack_public_path__ + "static/media/tete54.64e0a191.png";